export default "__VITE_ASSET__JM3qM_Qo__"